<template>
  <div style="min-height: 750px;">
    <b-card no-body :class="[d_fullScreen ? 'full-screen-mode' : 'normal-mode']">

      <b-row
        class="wai-topbar"
        :class="d_fullScreen ? 'wai-topbar-fullscreen' : ''"
      >
        <b-col sm="12" lg="6" class="wai-topbar-left">

          <b-dropdown
            id="dropdown-grouped"
            variant="outline-white"
            no-caret
            class="wai-project-dropdown"
            ref="dropdown_projects"
          >
            <template #button-content>
              <div class="wai-project-selector">
                <div class="wai-project-icon">
                  <i class="fa fa-search"></i>
                </div>

                <div class="wai-project-text">
                  <div class="wai-project-label">
                    <span v-if="d_selectedProjectOrderedType === 'ordered' && d_selectedProjectType && d_projectList[d_selectedProjectType] && d_selectedProjectIndex !== ''">
                      {{ d_projectList[d_selectedProjectType][d_selectedProjectIndex]['name'][StoreLang] }}
                    </span>

                    <span v-else-if="d_selectedProjectOrderedType === 'unordered' && d_noOrderedSource === 'dataset' && d_selectedProjectType && d_datasetList[d_selectedProjectType] && d_selectedProjectIndex !== '' && d_datasetList[d_selectedProjectType][d_selectedProjectIndex]['data'] && d_datasetList[d_selectedProjectType][d_selectedProjectIndex]['data']['0'] && d_datasetList[d_selectedProjectType][d_selectedProjectIndex]['data']['0']['1'] && d_datasetList[d_selectedProjectType][d_selectedProjectIndex]['data']['0']['1']['lang'] && d_datasetList[d_selectedProjectType][d_selectedProjectIndex]['data']['0']['1']['lang'][StoreLang]">
                      {{ d_datasetList[d_selectedProjectType][d_selectedProjectIndex]['data']['0']['1']['lang'][StoreLang] }}
                    </span>

                    <span v-else-if="d_selectedProjectOrderedType === 'unordered' && d_selectedProjectType && d_noNeedOrderProjectList[d_selectedProjectType] && d_selectedProjectIndex !== '' && d_noNeedOrderProjectList[d_selectedProjectType][d_selectedProjectIndex]['data'] && d_noNeedOrderProjectList[d_selectedProjectType][d_selectedProjectIndex]['data']['0'] && d_noNeedOrderProjectList[d_selectedProjectType][d_selectedProjectIndex]['data']['0']['1'] && d_noNeedOrderProjectList[d_selectedProjectType][d_selectedProjectIndex]['data']['0']['1']['lang'] && d_noNeedOrderProjectList[d_selectedProjectType][d_selectedProjectIndex]['data']['0']['1']['lang'][StoreLang]">
                      {{ d_noNeedOrderProjectList[d_selectedProjectType][d_selectedProjectIndex]['data']['0']['1']['lang'][StoreLang] }}
                    </span>

                    <span v-else>
                      {{ StoreLangTranslation.data['projects'][StoreLang] }}
                    </span>
                  </div>

                  <div class="wai-project-date">
                    <span v-if="d_selectedProjectOrderedType === 'ordered' && d_selectedProjectType && d_projectList[d_selectedProjectType] && d_selectedProjectIndex !== ''">
                      {{ d_selectedProjectIndex !== '' && d_projectList[d_selectedProjectType][d_selectedProjectIndex]['wanalyzer_project_create_date'] ? f_dateFormat(d_projectList[d_selectedProjectType][d_selectedProjectIndex]['wanalyzer_project_create_date'], 'year-month-day hh:mm') : '' }}
                    </span>

                    <span v-else-if="d_selectedProjectOrderedType === 'unordered' && d_noOrderedSource === 'dataset' && d_selectedProjectType && d_datasetList[d_selectedProjectType] && d_selectedProjectIndex !== ''">
                      {{ d_selectedProjectIndex !== '' && d_datasetList[d_selectedProjectType][d_selectedProjectIndex]['created_at'] ? f_dateFormat(d_datasetList[d_selectedProjectType][d_selectedProjectIndex]['created_at'], 'year-month-day hh:mm') : '' }}
                    </span>

                    <span v-else-if="d_selectedProjectOrderedType === 'unordered' && d_selectedProjectType && d_noNeedOrderProjectList[d_selectedProjectType] && d_selectedProjectIndex !== ''">
                      {{ d_selectedProjectIndex !== '' && d_noNeedOrderProjectList[d_selectedProjectType][d_selectedProjectIndex]['created_at'] ? f_dateFormat(d_noNeedOrderProjectList[d_selectedProjectType][d_selectedProjectIndex]['created_at'], 'year-month-day hh:mm') : '' }}
                    </span>

                    <span v-else>
                      Select analytics workspace
                    </span>
                  </div>
                </div>

                <div class="wai-project-caret">
                  <i class="fa fa-chevron-down"></i>
                </div>
              </div>
            </template>

            <div class="wai-dropdown-panel">
              <div class="wai-dropdown-search">
                <div class="wai-search-icon">
                  <i class="fa fa-search"></i>
                </div>

                <b-form-input
                  v-model="d_searchText"
                  class="wai-search-input"
                  :placeholder="StoreLangTranslation.data['write_for_filtering'][StoreLang]"
                ></b-form-input>

                <button class="wai-clear-button" @click="d_searchText = ''">
                  <i class="fa fa-trash"></i>
                </button>
              </div>

              <div class="wai-project-list">
                <template v-for="(project_list, project_type) in d_projectList">
                  <template v-if="project_list.length > 0 && f_searchInProjectList(project_list)">

                    <b-dropdown-group
                      :id="project_type"
                      :header="StoreLangTranslation.data[project_type][StoreLang]"
                      class="wai-dropdown-group"
                    >
                      <template #header>
                        <div class="wai-group-header">
                          <i :class="d_icons[project_type]['title']"></i>
                          <span>{{ StoreLangTranslation.data[project_type][StoreLang] }}</span>
                        </div>
                      </template>

                      <template v-if="project_type === 'wanalyzer_create_query'">
                        <template v-for="(scope, scopeIndex) in d_scopeList">
                          <b-row
                            v-b-toggle="'project_collapse_' + scopeIndex"
                            class="wai-scope-row"
                          >
                            <b-col cols="1">
                              <i class="fa fa-folder-o"></i>
                            </b-col>
                            <b-col cols="11">
                              <i class="fa fa-chevron-down"></i>
                              <span>{{ scope }}</span>
                            </b-col>
                          </b-row>

                          <b-collapse :id="'project_collapse_' + scopeIndex" :visible="false">
                            <template
                              v-if="project['wanalyzer_project_scope'] && project['wanalyzer_project_scope'] === scope && f_searchItem(project.name[StoreLang])"
                              v-for="(project, project_index) in project_list"
                            >
                              <b-dropdown-item-button
                                @click="f_selectProject(project_type, project_index)"
                                :class="d_selectedProjectOrderedType === 'ordered' && d_selectedProjectType === project_type && project_index === d_selectedProjectIndex ? 'wai-project-item-selected' : 'wai-project-item'"
                              >
                                <div class="wai-project-item-inner">
                                  <i :class="d_icons[project_type]['subtitle']"></i>
                                  <span>{{ project.name[StoreLang] }}</span>
                                </div>
                              </b-dropdown-item-button>
                            </template>
                          </b-collapse>
                        </template>

                        <template>
                          <b-row
                            v-b-toggle="'project_collapse_no_scope'"
                            class="wai-scope-row"
                          >
                            <b-col cols="1">
                              <i class="fa fa-folder-open-o"></i>
                            </b-col>
                            <b-col cols="11">
                              <i class="fa fa-chevron-down"></i>
                              <span>{{ StoreLangTranslation.data['no_scope'][StoreLang] }}</span>
                            </b-col>
                          </b-row>

                          <b-collapse :id="'project_collapse_no_scope'" :visible="false">
                            <template
                              v-if="(!project['wanalyzer_project_scope'] || (project['wanalyzer_project_scope'] && project['wanalyzer_project_scope'] == '')) && f_searchItem(project.name[StoreLang])"
                              v-for="(project, project_index) in project_list"
                            >
                              <b-dropdown-item-button
                                @click="f_selectProject(project_type, project_index)"
                                :class="d_selectedProjectOrderedType === 'ordered' && d_selectedProjectType === project_type && project_index === d_selectedProjectIndex ? 'wai-project-item-selected' : 'wai-project-item'"
                              >
                                <div class="wai-project-item-inner">
                                  <i :class="d_icons[project_type]['subtitle']"></i>
                                  <span>{{ project.name[StoreLang] }}</span>
                                </div>
                              </b-dropdown-item-button>
                            </template>
                          </b-collapse>
                        </template>
                      </template>

                      <template v-else v-for="(project, project_index) in project_list">
                        <template v-if="f_searchItem(project.name[StoreLang])">
                          <b-dropdown-item-button
                            @click="f_selectProject(project_type, project_index)"
                            :class="d_selectedProjectOrderedType === 'ordered' && d_selectedProjectType === project_type && project_index === d_selectedProjectIndex ? 'wai-project-item-selected' : 'wai-project-item'"
                          >
                            <div class="wai-project-item-inner">
                              <i :class="d_icons[project_type]['subtitle']"></i>
                              <span>
                                {{ project.auth_data && project.auth_data.label ? project.auth_data.label : project.name[StoreLang] }}
                              </span>
                            </div>
                          </b-dropdown-item-button>
                        </template>
                      </template>
                    </b-dropdown-group>

                    <b-dropdown-divider></b-dropdown-divider>
                  </template>
                </template>

                <template v-if="f_hasAnyItems(d_noNeedOrderProjectList)">
                  <div class="wai-public-title">
                    <i class="fa fa-globe"></i>
                    <strong>Public Projects</strong>
                  </div>
                </template>

                <template v-for="(project_list, project_type) in d_noNeedOrderProjectList">
                  <template v-if="project_list.length > 0 && f_searchInProjectList(project_list)">
                    <b-dropdown-group :id="project_type" class="wai-dropdown-group">
                      <template #header>
                        <div class="wai-group-header">
                          <i :class="d_icons[project_type]['title']"></i>
                          <span>{{ StoreLangTranslation.data[project_type][StoreLang] }}</span>
                        </div>
                      </template>

                      <template v-for="(project, project_index) in project_list">
                        <template v-if="project['data'] && project['data']['0'] && project['data']['0']['1'] && project['data']['0']['1']['lang'] && project['data']['0']['1']['lang'][StoreLang] && f_searchItem(project['data']['0']['1']['lang'][StoreLang])">
                          <b-dropdown-item-button
                            @click="f_selectProject(project_type, project_index, 'unordered')"
                            :class="d_selectedProjectOrderedType === 'unordered' && d_selectedProjectType === project_type && project_index === d_selectedProjectIndex ? 'wai-project-item-selected' : 'wai-project-item'"
                          >
                            <div class="wai-project-item-inner">
                              <i :class="d_icons[project_type]['subtitle']"></i>
                              <span>
                                {{ project['data'] && project['data']['0'] && project['data']['0']['1'] && project['data']['0']['1']['lang'] && project['data']['0']['1']['lang'][StoreLang] ? project['data']['0']['1']['lang'][StoreLang] : project['label'] }}
                              </span>
                            </div>
                          </b-dropdown-item-button>
                        </template>
                      </template>
                    </b-dropdown-group>

                    <b-dropdown-divider></b-dropdown-divider>
                  </template>
                </template>

                <template v-if="ClsUser.f_checkUserAuth(['admin', 'shop_admin'])">
                  <template v-if="d_datasetListLoading">
                    <div class="wai-loading-row">
                      <b-spinner variant="primary" label="Spinning"></b-spinner>
                      <span>{{ StoreLangTranslation.data['dataset_list_loading'][StoreLang] }}</span>
                    </div>
                  </template>

                  <template v-else>
                    <template v-if="f_hasAnyItems(d_datasetList)">
                      <div class="wai-public-title">
                        <i class="fa fa-database"></i>
                        <strong>Dataset Projects</strong>
                      </div>
                    </template>

                    <template v-for="(project_list, project_type) in d_datasetList">
                      <template v-if="project_list.length > 0 && f_searchInProjectList(project_list)">
                        <b-dropdown-group :id="project_type" class="wai-dropdown-group">
                          <template v-for="(project, project_index) in project_list">
                            <template v-if="project['data'] && project['data']['0'] && project['data']['0']['1'] && project['data']['0']['1']['lang'] && project['data']['0']['1']['lang'][StoreLang] && f_searchItem(project['data']['0']['1']['lang'][StoreLang])">
                              <b-dropdown-item-button
                                @click="f_selectProject(project_type, project_index, 'unordered', 'dataset')"
                                :class="d_selectedProjectOrderedType === 'unordered' && d_selectedProjectType === project_type && project_index === d_selectedProjectIndex ? 'wai-project-item-selected' : 'wai-project-item'"
                              >
                                <div class="wai-project-item-inner">
                                  <i :class="d_icons[project_type]['subtitle']"></i>
                                  <span>
                                    {{ project['data'] && project['data']['0'] && project['data']['0']['1'] && project['data']['0']['1']['lang'] && project['data']['0']['1']['lang'][StoreLang] ? project['data']['0']['1']['lang'][StoreLang] : project['label'] }}
                                  </span>
                                </div>
                              </b-dropdown-item-button>
                            </template>
                          </template>
                        </b-dropdown-group>

                        <b-dropdown-divider></b-dropdown-divider>
                      </template>
                    </template>
                  </template>
                </template>
              </div>
            </div>
          </b-dropdown>
        </b-col>

        <b-col sm="12" lg="3" class="wai-topbar-center"></b-col>

        <b-col sm="12" lg="2" class="wai-topbar-action">
          <template v-if="d_userAuthorizationListLoading || d_noNeedOrderedProjectsListLoading">
            <div class="wai-loading-mini">
              <b-spinner variant="primary" label="Spinning"></b-spinner>
            </div>
          </template>

          <template v-else>
            <b-dropdown
              v-if="f_isThereNewProjectAddAuthorization()"
              id="dropdown-grouped"
              variant="outline-white"
              no-caret
              class="wai-new-project-dropdown"
            >
              <template #button-content>
                <div class="wai-new-project-button">
                  <i class="fa fa-plus"></i>
                  <span>{{ StoreLangTranslation.data['new_project'][StoreLang] }}</span>
                </div>
              </template>

              <div class="wai-dropdown-panel wai-auth-panel">
                <div class="wai-dropdown-search">
                  <div class="wai-search-icon">
                    <i class="fa fa-search"></i>
                  </div>

                  <b-form-input
                    v-model="d_searchAuthorization"
                    class="wai-search-input"
                    :placeholder="StoreLangTranslation.data['write_for_filtering'][StoreLang]"
                  ></b-form-input>

                  <button class="wai-clear-button" @click="d_searchAuthorization = ''">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>

                <template v-for="auth_code in d_useAuthCodeList">
                  <template v-if="d_userAuthorizationList[auth_code] && d_userAuthorizationList[auth_code].length > 0">
                    <b-dropdown-group
                      :id="auth_code"
                      :header="StoreLangTranslation.data[auth_code][StoreLang]"
                      class="wai-dropdown-group"
                    >
                      <template #header>
                        <div class="wai-group-header">
                          <i class="fa fa-key"></i>
                          <span>{{ StoreLangTranslation.data[auth_code][StoreLang] }}</span>
                        </div>
                      </template>

                      <template v-for="(user_auth_data, user_auth_data_index) in d_userAuthorizationList[auth_code]">
                        <b-dropdown-item-button
                          @click="f_useThisAuth(auth_code, user_auth_data)"
                          class="wai-project-item"
                        >
                          <div class="wai-auth-item">
                            <div>
                              <i class="fa fa-plus-circle"></i>
                              <strong>{{ user_auth_data.auth_data['label'] }}</strong>
                            </div>

                            <template v-if="user_auth_data.auth_data && user_auth_data.auth_data['data'] && user_auth_data.auth_data['data']['0'] && user_auth_data.auth_data['data']['0']['4'] && user_auth_data.auth_data['data']['0']['4']['val'] && user_auth_data.auth_data['data']['0']['4']['val']['value'] === '1'">
                              <div class="wai-credit-pill">
                                <template v-if="user_auth_data.auth_data['data']['0']['7'] && user_auth_data.auth_data['data']['0']['7']['val']">
                                  <span>{{ user_auth_data.auth_data['data']['0']['7']['val'] }}</span>
                                </template>
                                <template v-else>
                                  <span>0</span>
                                </template>

                                <span>/</span>

                                <template v-if="user_auth_data.auth_data['data']['0']['6'] && user_auth_data.auth_data['data']['0']['6']['val']">
                                  <span>{{ user_auth_data.auth_data['data']['0']['6']['val'] }}</span>
                                </template>
                              </div>
                            </template>
                          </div>
                        </b-dropdown-item-button>
                      </template>
                    </b-dropdown-group>

                    <b-dropdown-divider></b-dropdown-divider>
                  </template>
                </template>
              </div>
            </b-dropdown>
          </template>
        </b-col>

        <b-col sm="12" lg="1" class="wai-topbar-fullscreen-action">
          <b-button
            class="wai-fullscreen-button"
            size="lg"
            variant="white"
            @click="d_fullScreen ? d_fullScreen = false : d_fullScreen = true"
          >
            <i class="fa fa-desktop"></i>
          </b-button>
        </b-col>
      </b-row>




      <b-row :style="d_fullScreen ? 'margin-top: 50px;' : 'margin: 0px;'">
        <b-col sm="12" lg="12">
          <template v-if="d_selectedProjectIndex !== ''">

              <template v-if="d_selectedProjectType === 'wanalyzer_stats_view'">
                <b-row>
                  <b-col sm="12" lg="1"></b-col>
                  <b-col sm="12" lg="10">
                    <wanalyzer-stats-view v-if="d_selectedProjectOrderedType === 'ordered'" :key="d_selectedProjectOrderedType + '_' + d_selectedProjectType + '_' + d_selectedProjectIndex + '_' + d_keyIndex" :p_projectId="d_projectList[d_selectedProjectType][d_selectedProjectIndex].wanalyzer_project_id" :p_statsId="d_projectList[d_selectedProjectType][d_selectedProjectIndex].wanalyzer_stats_id" :p_authClientId="d_projectList[d_selectedProjectType][d_selectedProjectIndex].auth_data.client_id"></wanalyzer-stats-view>
                    <wanalyzer-stats-view v-if="d_selectedProjectOrderedType === 'unordered'" :key="d_selectedProjectOrderedType + '_' + d_selectedProjectType + '_' + d_selectedProjectIndex + '_' + d_keyIndex" :p_projectId="f_getProjectId(d_noNeedOrderProjectList, d_selectedProjectType, d_selectedProjectIndex)" :p_statsId="d_noNeedOrderProjectList[d_selectedProjectType][d_selectedProjectIndex]['data']['0']['38']['val']"></wanalyzer-stats-view>
                  </b-col>
                  <b-col sm="12" lg="1"></b-col>
                </b-row>
              </template>

              <template v-else-if="d_selectedProjectType === 'wanalyzer_dataset_filter'">
                  <wanalyzer-dataset-analyze v-if="d_selectedProjectOrderedType === 'ordered'" :key="d_selectedProjectOrderedType + '_' + d_selectedProjectType + '_' + d_selectedProjectIndex + '_' + d_keyIndex" :p_projectId="d_projectList[d_selectedProjectType][d_selectedProjectIndex].wanalyzer_project_id" :f_getUserAuthorizationList="f_getUserAuthorizationList" :f_getThisUserAuth="f_getThisUserAuth" :p_selectedProjectType="d_selectedProjectType" :p_projectPermission="d_projectList[d_selectedProjectType][d_selectedProjectIndex]" :p_fullScreen="d_fullScreen"  :p_creditAuthData="d_creditAuthData"></wanalyzer-dataset-analyze>
                  <wanalyzer-dataset-analyze v-else-if="d_selectedProjectOrderedType === 'unordered' && d_noOrderedSource === 'dataset'" :p_datasetAdmin="true" :f_getDatasetProjects="f_getDatasetProjects" :key="d_selectedProjectOrderedType + '_' + d_selectedProjectType + '_' + d_selectedProjectIndex + '_' + d_keyIndex" :p_projectId="f_getProjectId(d_datasetList, d_selectedProjectType, d_selectedProjectIndex)" :f_getUserAuthorizationList="f_getUserAuthorizationList" :f_getThisUserAuth="f_getThisUserAuth" :p_selectedProjectType="d_selectedProjectType" :p_fullScreen="d_fullScreen"  :p_creditAuthData="d_creditAuthData" :p_datasetList="d_datasetList"></wanalyzer-dataset-analyze>
                  <wanalyzer-dataset-analyze v-else-if="d_selectedProjectOrderedType === 'unordered'" :key="d_selectedProjectOrderedType + '_' + d_selectedProjectType + '_' + d_selectedProjectIndex + '_' + d_keyIndex" :p_projectId="f_getProjectId(d_noNeedOrderProjectList, d_selectedProjectType, d_selectedProjectIndex)" :f_getUserAuthorizationList="f_getUserAuthorizationList" :f_getThisUserAuth="f_getThisUserAuth" :p_selectedProjectType="d_selectedProjectType" :p_fullScreen="d_fullScreen"  :p_creditAuthData="d_creditAuthData"></wanalyzer-dataset-analyze>
              </template>

              <template v-else-if="d_selectedProjectType === 'wanalyzer_dataset_stats_query'">
                  <wanalyzer-dataset-analyze v-if="d_selectedProjectOrderedType === 'ordered'" :key="d_selectedProjectOrderedType + '_' + d_selectedProjectType + '_' + d_selectedProjectIndex + '_' + d_keyIndex" :p_projectId="d_projectList[d_selectedProjectType][d_selectedProjectIndex].wanalyzer_project_id" :f_getUserAuthorizationList="f_getUserAuthorizationList" :f_getThisUserAuth="f_getThisUserAuth" :p_selectedProjectType="d_selectedProjectType" :p_projectPermission="d_projectList[d_selectedProjectType][d_selectedProjectIndex]" :p_fullScreen="d_fullScreen"  :p_creditAuthData="d_creditAuthData"></wanalyzer-dataset-analyze>
                  <wanalyzer-dataset-analyze v-if="d_selectedProjectOrderedType === 'unordered'" :key="d_selectedProjectOrderedType + '_' + d_selectedProjectType + '_' + d_selectedProjectIndex + '_' + d_keyIndex" :p_projectId="f_getProjectId(d_noNeedOrderProjectList, d_selectedProjectType, d_selectedProjectIndex)" :f_getUserAuthorizationList="f_getUserAuthorizationList" :f_getThisUserAuth="f_getThisUserAuth" :p_selectedProjectType="d_selectedProjectType" :p_fullScreen="d_fullScreen"  :p_creditAuthData="d_creditAuthData"></wanalyzer-dataset-analyze>
              </template>

              <template v-else-if="d_selectedProjectType === 'wanalyzer_machinelearning_query'">
                <b-row>
                  <b-col sm="12" lg="1"></b-col>
                  <b-col sm="12" lg="10">
                  <machine-learning-query v-if="d_selectedProjectOrderedType === 'ordered'" :key="d_selectedProjectOrderedType + '_' + d_selectedProjectType + '_' + d_selectedProjectIndex + '_' + d_keyIndex" :p_projectId="d_projectList[d_selectedProjectType][d_selectedProjectIndex].wanalyzer_project_id" :p_machineLearningId="d_projectList[d_selectedProjectType][d_selectedProjectIndex].wanalyzer_machine_learning_id" :p_authClientId="d_projectList[d_selectedProjectType][d_selectedProjectIndex].auth_data.client_id"></machine-learning-query>
                  <machine-learning-query v-if="d_selectedProjectOrderedType === 'unordered'" :key="d_selectedProjectOrderedType + '_' + d_selectedProjectType + '_' + d_selectedProjectIndex + '_' + d_keyIndex" :p_projectId="f_getProjectId(d_noNeedOrderProjectList, d_selectedProjectType, d_selectedProjectIndex)" :p_machineLearningId="d_noNeedOrderProjectList[d_selectedProjectType][d_selectedProjectIndex]['data']['0']['39']['val']"></machine-learning-query>
                  </b-col>
                  <b-col sm="12" lg="1"></b-col>
                </b-row>

              </template>

              <template v-else-if="d_selectedProjectType === 'wanalyzer_cell_calculate'">
                  <wanalyzer-cell-calculate v-if="d_selectedProjectOrderedType === 'ordered'" :key="d_selectedProjectOrderedType + '_' + d_selectedProjectType + '_' + d_selectedProjectIndex + '_' + d_keyIndex" :p_projectId="d_projectList[d_selectedProjectType][d_selectedProjectIndex].wanalyzer_project_id" :p_idType="d_projectList[d_selectedProjectType][d_selectedProjectIndex].id_type" :p_authClientId="d_projectList[d_selectedProjectType][d_selectedProjectIndex].auth_data.client_id" :p_fullScreen="d_fullScreen" ></wanalyzer-cell-calculate>
                  <wanalyzer-cell-calculate v-if="d_selectedProjectOrderedType === 'unordered'" :key="d_selectedProjectOrderedType + '_' + d_selectedProjectType + '_' + d_selectedProjectIndex + '_' + d_keyIndex" :p_projectId="f_getProjectId(d_noNeedOrderProjectList, d_selectedProjectType, d_selectedProjectIndex)" :p_idType="'client_id_based'" :p_fullScreen="d_fullScreen" ></wanalyzer-cell-calculate>
              </template>
            
              <template v-else-if="d_selectedProjectType === 'wanalyzer_create_query'">
                <wanalyzer-dataset-analyze v-if="d_selectedProjectOrderedType === 'ordered'" :key="d_selectedProjectOrderedType + '_' + d_selectedProjectType + '_' + d_selectedProjectIndex + '_' + d_keyIndex" :p_projectId="d_projectList[d_selectedProjectType][d_selectedProjectIndex].wanalyzer_project_id" :f_getUserAuthorizationList="f_getUserAuthorizationList" :f_getThisUserAuth="f_getThisUserAuth" :p_selectedProjectType="d_selectedProjectType" :p_projectPermission="d_projectList[d_selectedProjectType][d_selectedProjectIndex]" :p_fullScreen="d_fullScreen" :p_scopeList="d_scopeList" :f_getScopes="f_getScopes" :p_projectList="d_projectList" :p_selectedProjectIndex="d_selectedProjectIndex" :p_creditAuthData="d_creditAuthData"></wanalyzer-dataset-analyze>
                <wanalyzer-dataset-analyze v-if="d_selectedProjectOrderedType === 'unordered'" :key="d_selectedProjectOrderedType + '_' + d_selectedProjectType + '_' + d_selectedProjectIndex + '_' + d_keyIndex" :p_projectId="f_getProjectId(d_noNeedOrderProjectList, d_selectedProjectType, d_selectedProjectIndex)" :f_getUserAuthorizationList="f_getUserAuthorizationList" :f_getThisUserAuth="f_getThisUserAuth" :p_selectedProjectType="d_selectedProjectType" :p_fullScreen="d_fullScreen" :p_scopeList="d_scopeList" :f_getScopes="f_getScopes" :p_projectList="d_noNeedOrderProjectList" :p_selectedProjectIndex="d_selectedProjectIndex" :p_creditAuthData="d_creditAuthData"></wanalyzer-dataset-analyze>
              </template>

              <template v-else-if="d_selectedProjectType === 'wanalyzer_credit_count'">
                <wanalyzer-dataset-analyze :key="d_selectedProjectType + '_' + d_selectedProjectIndex + '_' + d_keyIndex" :p_projectId="d_projectList[d_selectedProjectType][d_selectedProjectIndex].wanalyzer_project_id" :f_getUserAuthorizationList="f_getUserAuthorizationList" :f_getThisUserAuth="f_getThisUserAuth" :p_selectedProjectType="d_selectedProjectType" :p_projectPermission="d_projectList[d_selectedProjectType][d_selectedProjectIndex]" :p_fullScreen="d_fullScreen" :p_scopeList="d_scopeList" :f_getScopes="f_getScopes" :p_projectList="d_projectList" :p_selectedProjectIndex="d_selectedProjectIndex" :p_creditAuthData="d_creditAuthData"></wanalyzer-dataset-analyze>
              </template>
            
          </template>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-if="d_supportData.show" id="d_supportData_show" v-model="d_supportData.show" scrollable hide-footer :title="StoreLangTranslation.data['support_screen'][StoreLang]" centered header-bg-variant="info" header-text-variant="dark" size="lg">
      <p>
        <b-row>
          <b-col sm="12" lg="12"></b-col>
        </b-row>
      </p>
      <p>
      <b-row>
          <b-col sm="12" lg="6"></b-col>
          <b-col sm="12" lg="6" style="text-align: right;">
          </b-col>
        </b-row>
      </p>
    </b-modal>
  </div>
</template>

<script>
import { ClsRoute } from '@/wam/modules/route';
import { ClsUser } from '@/wam/modules/user';
import {
  default as MachineLearningResult
} from "@/components/widgets/MachineLearningResult";
import {
  default as MachineLearningQuery
} from "@/components/widgets/MachineLearningQuery";
import {
  default as WanalyzerCellCalculate
} from "@/components/widgets/WanalyzerCellCalculate";
import {
  default as WanalyzerDatasetAnalyze
} from "@/components/widgets/WanalyzerDatasetAnalyze";
import {
  default as WanalyzerStatsView
} from "@/components/widgets/WanalyzerStatsView";
import store from '@/store';
import { ServiceFunctions } from '@/wam/modules/service';
import {
  default as PageInfo
} from '@/components/widgets/PageInfo';
import { mapGetters } from 'vuex';
import moment from "moment";
export default {
  name: 'UserProjectProcess',
  computed: mapGetters({
    StoreDevice: 'StoreDevice',
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',
  }),
  components: {
    PageInfo,
    MachineLearningResult,
    MachineLearningQuery,
    WanalyzerCellCalculate,
    WanalyzerDatasetAnalyze,
    WanalyzerStatsView,
  },
  props: {},
  data () {
    return {
      ClsUser: ClsUser,
      d_fullScreen: true,
      d_useCreateEligibleAuthCodeList: ['wanalyzer_create_query','wanalyzer_credit_count'],
      d_useAuthCodeList: ['wanalyzer_stats_view','wanalyzer_dataset_filter','wanalyzer_dataset_stats_query','wanalyzer_machinelearning_query','wanalyzer_create_query', 'wanalyzer_credit_count'],
      d_searchAuthorization: '',
      d_creditAuthData: {},
      d_userAuthorizationList: {},
      d_userAuthorizationListLoading: false,
      d_noNeedOrderedProjectsListLoading: false,
      d_selectedWanalyzerCreateQuery: 'general_settings',
      d_selectedProjectType: '',
      d_selectedProjectIndex: '',
      d_projectList: {
        'wanalyzer_stats_view': [],
        'wanalyzer_dataset_filter': [],
        'wanalyzer_dataset_stats_query': [],
        'wanalyzer_machinelearning_query': [],
        'wanalyzer_create_query': [],
      },
      d_testProjectList: {
        "wanalyzer_stats_view": [
            {
              "name": {"en": "ALK Pozitif istatistiği", "tr": "ALK Pozitif istatistiği"},
              "shop_name":{"en": "Evideep Market", "tr": "Evideep Market"},
              "shop_client_id": "6da6233a-38ee-4fbe-946b-e3152709b789",
              "shopcart_bundle_name": {"tr": "Akciğer Kanseri Genetik ALK Pozitif [evideep1]", "en": "Lung Cancer Genetic ALK Positive [evideep1]"},
              "shopcart_bundle_client_id": "evideep_47603a1b-63a5-4d29-ab99-f0f0c309dc8a",
              "shopcart_product_name": {"tr": "akciğer kanseri genetik alk son 1 hafta pozitif aboneliği yıllık", "en": "lung cancer genetic alk positive subscription annual"},
              "shopcart_product_client_id": "9bab4cdd-b066-4099-8767-dabc13f6ba7d",
              "wanalyzer_project_name": "Akciğer Kanseri Genetik ALK Pozitif Projesi",
              "wanalyzer_project_id": "615a309c-fa5c-4d23-aedd-2c0d08443459",
              "wanalyzer_stats_name": "ALK Pozitif istatistiği",
              "wanalyzer_stats_id": "5b13faea-3dc3-4a24-852e-14ba80dd084d",
              "wanalyzer_machine_learning_name": "",
              "wanalyzer_machine_learning_id": "",
            }
        ],
        "wanalyzer_dataset_filter": [
            {
              "name": {"en": "Akciğer Kanseri Genetik ALK Pozitif Projesi", "tr": "Akciğer Kanseri Genetik ALK Pozitif Projesi"},
              "shop_name":{"en": "Evideep Market", "tr": "Evideep Market"},
              "shop_client_id": "6da6233a-38ee-4fbe-946b-e3152709b789",
              "shopcart_bundle_name": {"tr": "Akciğer Kanseri Genetik ALK Pozitif [evideep1]", "en": "Lung Cancer Genetic ALK Positive [evideep1]"},
              "shopcart_bundle_client_id": "evideep_47603a1b-63a5-4d29-ab99-f0f0c309dc8a",
              "shopcart_product_name": {"tr": "akciğer kanseri genetik alk son 1 hafta pozitif aboneliği yıllık", "en": "lung cancer genetic alk positive subscription annual"},
              "shopcart_product_client_id": "9bab4cdd-b066-4099-8767-dabc13f6ba7d",
              "wanalyzer_project_name": "Akciğer Kanseri Genetik ALK Pozitif Projesi",
              "wanalyzer_project_id": "615a309c-fa5c-4d23-aedd-2c0d08443459",
              "wanalyzer_stats_name": "",
              "wanalyzer_stats_id": "",
              "wanalyzer_machine_learning_name": "",
              "wanalyzer_machine_learning_id": "",
            }
        ],
        "wanalyzer_dataset_stats_query": [
            {
              "name": {"en": "Akciğer Kanseri Genetik ALK Pozitif Projesi", "tr": "Akciğer Kanseri Genetik ALK Pozitif Projesi"},
              "shop_name":{"en": "Evideep Market", "tr": "Evideep Market"},
              "shop_client_id": "6da6233a-38ee-4fbe-946b-e3152709b789",
              "shopcart_bundle_name": {"tr": "Akciğer Kanseri Genetik ALK Pozitif [evideep1]", "en": "Lung Cancer Genetic ALK Positive [evideep1]"},
              "shopcart_bundle_client_id": "evideep_47603a1b-63a5-4d29-ab99-f0f0c309dc8a",
              "shopcart_product_name": {"tr": "akciğer kanseri genetik alk son 1 hafta pozitif aboneliği yıllık", "en": "lung cancer genetic alk positive subscription annual"},
              "shopcart_product_client_id": "9bab4cdd-b066-4099-8767-dabc13f6ba7d",
              "wanalyzer_project_name": "Akciğer Kanseri Genetik ALK Pozitif Projesi",
              "wanalyzer_project_id": "615a309c-fa5c-4d23-aedd-2c0d08443459",
              "wanalyzer_stats_name": "",
              "wanalyzer_stats_id": "",
              "wanalyzer_machine_learning_name": "",
              "wanalyzer_machine_learning_id": "",
            }
        ],
        "wanalyzer_machinelearning_query": [
            {
              "name": {"en": "Overall Survival Analyze For Lung Cancer And Alk Gene Positive Patients", "tr": "Overall Survival Analyze For Lung Cancer And Alk Gene Positive Patients"},
              "shop_name":{"en": "Evideep Market", "tr": "Evideep Market"},
              "shop_client_id": "6da6233a-38ee-4fbe-946b-e3152709b789",
              "shopcart_bundle_name": {"tr": "Akciğer Kanseri Genetik ALK Pozitif [evideep1]", "en": "Lung Cancer Genetic ALK Positive [evideep1]"},
              "shopcart_bundle_client_id": "evideep_47603a1b-63a5-4d29-ab99-f0f0c309dc8a",
              "shopcart_product_name": {"tr": "akciğer kanseri genetik alk son 1 hafta pozitif aboneliği yıllık", "en": "lung cancer genetic alk positive subscription annual"},
              "shopcart_product_client_id": "9bab4cdd-b066-4099-8767-dabc13f6ba7d",
              "wanalyzer_project_name": "Overall Survival Analyze For Lung Cancer And Alk Gene Positive Patients",
              "wanalyzer_project_id": "5ca4d0bc-7057-444b-ba93-eab11a92b524",
              "wanalyzer_stats_name": "",
              "wanalyzer_stats_id": "",
              "wanalyzer_machine_learning_name": "Overall Survival Analyze For Lung Cancer And Alk Gene Positive Patients",
              "wanalyzer_machine_learning_id": "f1adb953-ead3-44c2-b00d-fedcd77f1002",
            }
        ],
        "wanalyzer_create_query": [
            {
              "name": {"en": "Tansiyon hastalığı olan vakalar", "tr": "Tansiyon hastalığı olan vakalar"},
              "shop_name":{"en": "Evideep Market", "tr": "Evideep Market"},
              "shop_client_id": "6da6233a-38ee-4fbe-946b-e3152709b789",
              "shopcart_bundle_name": {"tr": "İstanbul Hastaneleri Veri Sorgulama [evideep11]", "en": "Istanbul Hospitals Data Query [evideep11]"},
              "shopcart_bundle_client_id": "evideep_47603a1b-63a5-4d29-ab99-f0f0c309dc8a",
              "shopcart_product_name": {"tr": "akciğer kanseri genetik alk son 1 hafta pozitif aboneliği yıllık", "en": "lung cancer genetic alk positive subscription annual"},
              "shopcart_product_client_id": "9bab4cdd-b066-4099-8767-dabc13f6ba7d",
              "wanalyzer_project_name": "Tansiyon hastalığı olan vakalar",
              "wanalyzer_project_create_date": "2024-10-19T20:00:00.000000",
              "wanalyzer_project_id": "8bbaef08-a8a6-416f-9dc4-565a7a149582",
              "wanalyzer_stats_name": "",
              "wanalyzer_stats_id": "",
              "wanalyzer_machine_learning_name": "",
              "wanalyzer_machine_learning_id": "",
              "layer_list": [
                {
                  "layer": {"name": {"en": "patient", "tr": "hasta"}, "value": "hospital_patient_1"},
                  "parameter_usage_type": {"name": {"en": "all", "tr": "hepsi"}, "value": "0"},
                  "parameter_list": ""
                },
                {
                  "layer": {"name": {"en": "patient / visit", "tr": "hasta / başvuru"}, "value": "hospital_patient_2"},
                  "parameter_usage_type": {"name": {"en": "all", "tr": "hepsi"}, "value": "0"},
                  "parameter_list": ""
                },
                {
                  "layer": {"name": {"en": "patient / visit / diagnosis", "tr": "hasta / başvuru / tanı"}, "value": "hospital_patient_3"},
                  "parameter_usage_type": {"name": {"en": "all", "tr": "hepsi"}, "value": "0"},
                  "parameter_list": ""
                }
              ],
              "main_layer": "hospital_patient_1",
              "layer_tree_list": [
                {"name": {"en": "hospital patient", "tr": "hastane hasta"}, "value": "hospital_patient"}
              ],
              "layer_tree_list_set": {"name": {"en": "hospital patient", "tr": "hastane hasta"}, "value": "hospital_patient"},
              "location_list": [
                {
                  "name": {"en": "wtransfer1", "tr": "wtransfer1"},
                  "value": "wtransfer1",
                  "selected": 1,
                  "server_list": [
                    {"name": {"en": "MP - BAH", "tr": "MP - BAH"}, "value": "4", "selected": 0},
                    {"name": {"en": "MP - BHI", "tr": "MP - BHI"}, "value": "6", "selected": 0},
                    {"name": {"en": "MP - FLR", "tr": "MP - FLR"}, "value": "11", "selected": 0},
                    {"name": {"en": "MP - GEB", "tr": "MP - GEB"}, "value": "12", "selected": 0},
                    {"name": {"en": "MP - GOZ", "tr": "MP - GOZ"}, "value": "13", "selected": 1},
                    {"name": {"en": "MP - GZU", "tr": "MP - GZU"}, "value": "15", "selected": 0},
                    {"name": {"en": "MP - MLT", "tr": "MP - MLT"}, "value": "18", "selected": 0},
                  ]
                }
              ],
              "case_limit_count_set": "100",
              "case_limit_count": "10000",
              "main_rule_algorithm": {"query_list":[{"time_of_value":"any_value","data_type":"old_recorded_data","compile_str_array":["(",0,")"],"fields":[{"loc":[{"type":"group","value":"0","label":"Param"},{"type":"select","value":"2","label":"department"}],"using_data_if_not_reaching_record_data":"true","val_list":[{"translation":{"en":"medical oncology","tr":"medikal onkoloji"},"value":"102","label":"medikal onkoloji"}],"values":["102"],"significant":"true","value_type":"select","operation":"="}],"compile_str":"","significant":"true","date":"1","type":{"value":"hospital_patient_2","label":"patient visit"}}],"compile_str_array":["(",0,")"],"compile_str_date":[],"compile_str_text":[]},
              "main_rule_algorithm_set": {"query_list":[{"time_of_value":"any_value","data_type":"old_recorded_data","compile_str_array":["(",0,")"],"fields":[{"loc":[{"type":"group","value":"0","label":"Param"},{"type":"select","value":"2","label":"department"}],"using_data_if_not_reaching_record_data":"true","val_list":[{"translation":{"en":"medical oncology","tr":"medikal onkoloji"},"value":"102","label":"medikal onkoloji"}],"values":["102"],"significant":"true","value_type":"select","operation":"="}],"compile_str":"","significant":"true","date":"1","type":{"value":"hospital_patient_2","label":"patient visit"}}],"compile_str_array":["(",0,")"],"compile_str_date":[],"compile_str_text":[]}
            }
        ],
        "wanalyzer_cell_calculate": [
            {
              "name": {"en": "Tansiyon hastalığı olan vakalar", "tr": "Tansiyon hastalığı olan vakalar"},
              "shop_name":{"en": "Evideep Market", "tr": "Evideep Market"},
              "shop_client_id": "6da6233a-38ee-4fbe-946b-e3152709b789",
              "shopcart_bundle_name": {"tr": "Akciğer Kanseri Genetik ALK Pozitif [evideep1]", "en": "Lung Cancer Genetic ALK Positive [evideep1]"},
              "shopcart_bundle_client_id": "evideep_47603a1b-63a5-4d29-ab99-f0f0c309dc8a",
              "shopcart_product_name": {"tr": "akciğer kanseri genetik alk son 1 hafta pozitif aboneliği yıllık", "en": "lung cancer genetic alk positive subscription annual"},
              "shopcart_product_client_id": "9bab4cdd-b066-4099-8767-dabc13f6ba7d",
              "wanalyzer_project_name": "Tansiyon hastalığı olan vakalar",
              "wanalyzer_project_id": "8bbaef08-a8a6-416f-9dc4-565a7a149582",
              "wanalyzer_stats_name": "",
              "wanalyzer_stats_id": "",
              "wanalyzer_machine_learning_name": "",
              "wanalyzer_machine_learning_id": "",
              "id_type": "client_id_based",
            }
        ]
      },
      d_supportData: {
        'maximum_characters_name': 100,
        'maximum_characters_note': 500,
        'mail_status': true,
        'phone_status': true,
        'phone': '',
        'mail': '',
        'show': false,
        'edit_eligible': false,
        'operation_name': '',
        'operation_note': '',
        'operation_note_additional': '',
        'maximum_characters': 500,
        'subject': 'genel'
      },
      d_user: '',
      d_hoverIndex: '',
      d_searchText: '',
      d_frontendClientID: '',
      d_frontendList: [],
      d_userSuppportList: [],
      d_scopeList: [],
      d_noNeedOrderProjectList: {
        'wanalyzer_stats_view': [],
        'wanalyzer_dataset_filter': [],
        'wanalyzer_dataset_stats_query': [],
        'wanalyzer_machinelearning_query': [],
        'wanalyzer_create_query': [],
      },
      d_datasetList: {
        'wanalyzer_stats_view': [],
        'wanalyzer_dataset_filter': [],
        'wanalyzer_dataset_stats_query': [],
        'wanalyzer_machinelearning_query': [],
        'wanalyzer_create_query': [],
      },
      d_productTypeMapList: {
        '4': 'wanalyzer_stats_view',
        '5': 'wanalyzer_dataset_filter',
        '6': 'wanalyzer_dataset_stats_query',
        '7': 'wanalyzer_machinelearning_query',
        '8': 'wanalyzer_create_query'
      },
      d_selectedProjectOrderedType: '',
      d_icons: {
        'wanalyzer_create_query': {
          'title': 'fa fa-magic fa-xl',
          'subtitle': 'fa fa-magic fa-xs',
        },
        'wanalyzer_stats_view': {
          'title': 'fa fa-line-chart fa-lg',
          'subtitle': 'fa fa-line-chart fa-sm',
        },
        'wanalyzer_dataset_filter': {
          'title': 'fa fa-filter fa-lg',
          'subtitle': 'fa fa-filter fa-sm',
        },
        'wanalyzer_dataset_stats_query': {
          'title': 'fa fa-file-text-o fa-lg',
          'subtitle': 'fa fa-file-text-o fa-xs',
        },
        'wanalyzer_machinelearning_query': {
          'title': 'fa fa-cogs fa-lg',
          'subtitle': 'fa fa-cogs fa-xs',
        },
        'wanalyzer_cell_calculate': {
          'title': 'fa fa-calculator fa-lg',
          'subtitle': 'fa fa-calculator fa-sm',
        },
        'wanalyzer_credit_count': {
          'title': 'fa fa-magic fa-lg',
          'subtitle': 'fa fa-magic fa-sm',
        }
      },
      d_keyIndex: 0,
      d_datasetListLoading: false,
      d_noOrderedSource: '',
    };
  },
  created: function () {
    this.d_user = JSON.parse(localStorage.getItem('user'));
    const cleanUrl = window.location.origin + window.location.pathname;
    // console.log('this.StoreFrontendSettings: ',this.StoreFrontendSettings)
    if (!this.d_user && cleanUrl.startsWith("https://evideep.com")) {
      this.$router.push({ path: this.StoreLangTranslation.data['page_404_path'][this.StoreLang], query: {} });
    } else {
      if (this.d_user && this.d_user.username) {
        this.f_getUserAuthorizationList();
      }
      this.f_getNoNeedOrderedProjects();
      let is_admin = false;
      is_admin = ClsUser.f_checkUserAuth(['admin', 'shop_admin']);
      if (is_admin) {
        this.f_getDatasetProjects();
      }

    }
  },
  beforeMount () {},
  mounted: function () {
    // console.log(this.StoreFrontendSettings);
    if (!this.$route.query.project_id) {
      this.$refs.dropdown_projects.show(true);
    }
  },
  methods: {
    f_getProjectId: function (projectList, t, ind) {
      let val = '';
      try {
        if (projectList[t][ind]['data']['0']['37']['val']) {
          val = projectList[t][ind]['data']['0']['37']['val'];
        }
      } catch(err) {}
      return val;
    },
    f_hasAnyItems: function (projectList) {
      for (let typeIndex in projectList) {
        if (projectList[typeIndex].length > 0) {
          return true;
        }
      }
      return false;
    },
    f_getDatasetProjects: function () {
      this.d_datasetList = {
        'wanalyzer_stats_view': [],
        'wanalyzer_dataset_filter': [],
        'wanalyzer_dataset_stats_query': [],
        'wanalyzer_machinelearning_query': [],
        'wanalyzer_create_query': [],
      };
      this.d_datasetListLoading = true;
      let query = '';
      let data = {};
      ServiceFunctions.user_shop_bundle_dataset_product_list(query, data)
        .then(resp => {
          this.d_datasetListLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.list) {
              // console.log(resp.data.list);
              for (let i in resp.data.list) {
                let productType = '';
                try {
                  productType = resp.data.list[i]['data']['0']['36']['val']['value'];
                } catch(err) {}
                if (productType && productType in this.d_productTypeMapList && this.d_productTypeMapList[productType]) {
                  this.d_datasetList[this.d_productTypeMapList[productType]].push(resp.data.list[i]);
                }
              }
              if (this.$route.query.project_id && this.$route.query.project_type && !this.d_selectedProjectType && !this.d_selectedProjectIndex) {
                if (this.d_datasetList[this.$route.query.project_type]) {
                  for (let project_index in this.d_datasetList[this.$route.query.project_type]) {
                    let project_data = this.d_datasetList[this.$route.query.project_type][project_index];
                    let p_id = '';
                    try {
                      if (project_data['data']['0']['37']['val']) {
                        p_id = project_data['data']['0']['37']['val'];
                      }
                    } catch(err) {}
                    if (p_id === this.$route.query.project_id) {
                      this.d_selectedProjectType = this.$route.query.project_type;
                      this.d_selectedProjectIndex = parseInt(project_index);
                      this.d_selectedProjectOrderedType = 'unordered';
                      this.d_noOrderedSource = 'dataset';
                      break;
                    }
                  }
                }
              }
              // console.log(this.d_noNeedOrderProjectList)
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_getNoNeedOrderedProjects: function () {
      this.d_noNeedOrderedProjectsListLoading = true;
      let query = '';
      let data = {};
      ServiceFunctions.user_shop_bundle_no_need_order_list(query, data)
        .then(resp => {
          this.d_noNeedOrderedProjectsListLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.list) {
              // console.log(resp.data.list);
              for (let i in resp.data.list) {
                let productType = '';
                try {
                  productType = resp.data.list[i]['data']['0']['36']['val']['value'];
                } catch(err) {}
                if (productType && productType in this.d_productTypeMapList && this.d_productTypeMapList[productType]) {
                  this.d_noNeedOrderProjectList[this.d_productTypeMapList[productType]].push(resp.data.list[i]);
                }
              }
              if (this.$route.query.project_id && this.$route.query.project_type && !this.d_selectedProjectType && !this.d_selectedProjectIndex) {
                if (this.d_noNeedOrderProjectList[this.$route.query.project_type]) {
                  for (let project_index in this.d_noNeedOrderProjectList[this.$route.query.project_type]) {
                    let project_data = this.d_noNeedOrderProjectList[this.$route.query.project_type][project_index];
                    let p_id = '';
                    try {
                      if (project_data['data']['0']['37']['val']) {
                        p_id = project_data['data']['0']['37']['val'];
                      }
                    } catch(err) {}
                    if (p_id === this.$route.query.project_id) {
                      this.d_selectedProjectType = this.$route.query.project_type;
                      this.d_selectedProjectIndex = parseInt(project_index);
                      this.d_selectedProjectOrderedType = 'unordered';
                      break;
                    }
                  }
                }
              }
              // console.log(this.d_noNeedOrderProjectList)
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_isThereNewProjectAddAuthorization: function () {
      let eligible_new_project = false;
      for (let auth_code in this.d_useAuthCodeList) {
        if (this.d_userAuthorizationList[this.d_useAuthCodeList[auth_code]] && this.d_userAuthorizationList[this.d_useAuthCodeList[auth_code]].length > 0) {
          eligible_new_project = true;
          if (this.d_useAuthCodeList[auth_code] == 'wanalyzer_credit_count') {
            this.d_creditAuthData = this.d_userAuthorizationList[this.d_useAuthCodeList[auth_code]][0];
          }
        }
      }
      return eligible_new_project;
    },
    f_useThisAuth: function (auth_code, user_auth_data) {
      // console.log('auth_code: ',auth_code)
      // console.log('user_auth_data: ',user_auth_data)
      if (auth_code === 'wanalyzer_create_query' || auth_code === 'wanalyzer_credit_count') {
        this.d_selectedProjectType = '';
        this.d_selectedProjectIndex = '';
        setTimeout(function () {
          let new_permission_item = JSON.parse(JSON.stringify(user_auth_data));
          for (let i in new_permission_item.name) {
            if (i === 'tr') {
              new_permission_item.name[i] = 'yeni proje'
            } else if (i === 'en') {
              new_permission_item.name[i] = 'new project'
            }
          }
          if (!this.d_projectList[auth_code]) {
            this.d_projectList[auth_code] = [];
          }
          this.d_projectList[auth_code].push(new_permission_item);
          this.d_selectedProjectType = auth_code;
          this.d_selectedProjectIndex = this.d_projectList[auth_code].length - 1;
          this.d_selectedProjectOrderedType = 'ordered';
          let new_query = {
            'path': this.$route.path,
            'query': {}
          };
          this.$router.push(new_query);
        }.bind(this), 100)

      }
    },
    f_getThisUserAuth: function (user_auth_cl_id_list) {
      this.d_userAuthorizationListLoading = true;
      let query = '';
      let data = {'user_auth_client_id_list': user_auth_cl_id_list};
      ServiceFunctions.user_authorization_get(query, data)
        .then(resp => {
          this.d_userAuthorizationListLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            // console.log(resp.data)
            for (let i in resp.data.list) {
              console.log(resp.data.list[i])
              let wanalyzer_project_id = '';
              try {
                wanalyzer_project_id = resp.data.list[i].data['0']['12']['val'];
              } catch(err) {}

              let wanalyzer_stats_id = '';
              try {
                wanalyzer_stats_id = resp.data.list[i].data['0']['13']['val'];
              } catch(err) {}

              let wanalyzer_machine_learning_id = '';
              try {
                wanalyzer_machine_learning_id = resp.data.list[i].data['0']['14']['val'];
              } catch(err) {}
              let auth_code = '';
              try {
                auth_code = resp.data.list[i].data['0']['1']['val'];
              } catch(err) {}
              if (auth_code) {
                console.log("auth_code: ",auth_code)
                if (wanalyzer_project_id || wanalyzer_stats_id || wanalyzer_machine_learning_id) {
                  if (!this.d_projectList[auth_code]) {
                    this.d_projectList[auth_code] = [];
                  }
                  let push_eligible = true;
                  for (let auth_index in this.d_projectList[auth_code]) {
                    if (resp.data.list[i].data === this.d_projectList[auth_code][auth_index]['auth_data']['client_id']) {
                      this.d_projectList[auth_code][auth_index] = resp.data.list[i];
                      push_eligible = false;
                      break;
                    }
                  }
                  console.log("push_eligible: ",push_eligible)
                  if (push_eligible) {
                    this.d_projectList[auth_code].push(resp.data.list[i]);
                  }

                } else {
                  if (this.d_useCreateEligibleAuthCodeList.indexOf(auth_code) !== -1) {
                    console.log("index -1")
                    if (!this.d_userAuthorizationList[auth_code]) {
                      this.d_userAuthorizationList[auth_code] = [];
                    }
                    this.d_userAuthorizationList[auth_code].push(resp.data.list[i]);
                  } else {
                    console.log("burda atması lazım düzgünce")
                    let indx = this.d_useCreateEligibleAuthCodeList.indexOf(auth_code)
                    this.d_userAuthorizationList[auth_code][indx] = resp.data.list[i];
                  }
                }
              }
            }

            if (this.$route.query.project_id && this.$route.query.project_type && !this.d_selectedProjectType && !this.d_selectedProjectIndex) {
              if (this.d_projectList[this.$route.query.project_type]) {
                for (let project_index in this.d_projectList[this.$route.query.project_type]) {
                  let project_data = this.d_projectList[this.$route.query.project_type][project_index];
                  if (project_data.wanalyzer_project_id === this.$route.query.project_id) {
                    this.d_selectedProjectType = this.$route.query.project_type;
                    this.d_selectedProjectIndex = parseInt(project_index);
                    this.d_selectedProjectOrderedType = 'ordered';
                    break;
                  }
                }
              }
            }
            this.f_getScopes();
            console.log("this.d_projectList: ",this.d_projectList)
            console.log("this.d_userAuthorizationList: ",this.d_userAuthorizationList)
          } else {
            let txt = 'status_code = ' + resp.data.status_code + '\n';
            txt += 'status_message = ' + resp.data.status_message;
            alert(txt);
          }
        });
    },
    f_getUserAuthorizationList: function () {
      this.d_userAuthorizationListLoading = true;
      let query = 'user_client_id=' + this.d_user.username;
      // auth_status=active, passive
      query += '&auth_status=active';
      // auth_type=general, product, shop
      // query += '&auth_type=' + auth_type;
      let data = {};
      this.d_userAuthorizationList = {};
      this.d_projectList = {
        'wanalyzer_stats_view': [],
        'wanalyzer_dataset_filter': [],
        'wanalyzer_dataset_stats_query': [],
        'wanalyzer_machinelearning_query': [],
        'wanalyzer_create_query': []
      };
      ServiceFunctions.user_authorization_list(query, data)
        .then(resp => {
          this.d_userAuthorizationListLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            for (let i in resp.data.list) {
              let wanalyzer_project_id = '';
              try {
                wanalyzer_project_id = resp.data.list[i].auth_data.data['0']['12']['val'];
              } catch(err) {}

              let wanalyzer_stats_id = '';
              try {
                wanalyzer_stats_id = resp.data.list[i].auth_data.data['0']['13']['val'];
              } catch(err) {}

              let wanalyzer_machine_learning_id = '';
              try {
                wanalyzer_machine_learning_id = resp.data.list[i].auth_data.data['0']['14']['val'];
              } catch(err) {}
              let auth_code = '';
              try {
                auth_code = resp.data.list[i].auth_data.data['0']['1']['val'];
              } catch(err) {}
              if (auth_code) {
                if (wanalyzer_project_id || wanalyzer_stats_id || wanalyzer_machine_learning_id) {
                  if (!this.d_projectList[auth_code]) {
                    this.d_projectList[auth_code] = [];
                  }
                  this.d_projectList[auth_code].push(resp.data.list[i]);
                } else {
                  if (this.d_useCreateEligibleAuthCodeList.indexOf(auth_code) !== -1) {
                    if (!this.d_userAuthorizationList[auth_code]) {
                      this.d_userAuthorizationList[auth_code] = [];
                    }
                    this.d_userAuthorizationList[auth_code].push(resp.data.list[i]);
                  }
                }
              }
            }

            if (this.$route.query.project_id && this.$route.query.project_type && !this.d_selectedProjectType && !this.d_selectedProjectIndex) {
              if (this.d_projectList[this.$route.query.project_type]) {
                for (let project_index in this.d_projectList[this.$route.query.project_type]) {
                  let project_data = this.d_projectList[this.$route.query.project_type][project_index];
                  if (project_data.wanalyzer_project_id === this.$route.query.project_id) {
                    this.d_selectedProjectType = this.$route.query.project_type;
                    this.d_selectedProjectIndex = parseInt(project_index);
                    this.d_selectedProjectOrderedType = 'ordered';
                    break;
                  }
                }
              }
            }
            this.f_getScopes();
          } else {
            let txt = 'status_code = ' + resp.data.status_code + '\n';
            txt += 'status_message = ' + resp.data.status_message;
            alert(txt);
          }
        });
    },
    f_searchInProjectList: function (project_list) {
      let res = false;
      if (this.d_searchText) {
        for (let project_index in project_list) {
            try {
              if (project_list[project_index].name[this.StoreLang].toLocaleLowerCase().indexOf(this.d_searchText.toLocaleLowerCase()) !== -1) {
                res = true;
                break;
              }
            } catch(err) {}
            if (!res) {
              try {
                if (project_list[project_index]['data']['0']['1']['lang'][this.StoreLang].toLocaleLowerCase().indexOf(this.d_searchText.toLocaleLowerCase()) !== -1) {
                  res = true;
                  break;
                }
              } catch(err) {}
            }
        }
      } else {
        res = true;
      }
      return res;
    },
    f_searchItem: function (searching_text) {
      let res = false;
      if (this.d_searchText) {
        try {
          if (searching_text.toLocaleLowerCase().indexOf(this.d_searchText.toLocaleLowerCase()) !== -1) {
            res = true;
          }
        } catch(err) {}
      } else {
        res = true;
      }
      return res;
    },
    f_selectProject: function (project_type, project_index, ordered_type = 'ordered', no_ordered_source) {
      this.d_searchText = '';
      this.d_selectedProjectType = project_type;
      this.d_selectedProjectIndex = project_index;
      // console.log('this.$route : ', this.$route);
      let route_path = '';
      if (this.d_selectedProjectType === 'wanalyzer_dataset_filter') {
        route_path = ClsRoute.f_getRoutePath('user_project_dataset_filter', this.StoreLang);
      } else if (this.d_selectedProjectType === 'wanalyzer_dataset_stats_query') {
        route_path = ClsRoute.f_getRoutePath('user_project_dataset_statistics_query', this.StoreLang);
      } else if (this.d_selectedProjectType === 'wanalyzer_machinelearning_query') {
        route_path = ClsRoute.f_getRoutePath('user_project_machine_learning', this.StoreLang);
      } else if (this.d_selectedProjectType === 'wanalyzer_stats_view') {
        route_path = ClsRoute.f_getRoutePath('user_project_statistics_view', this.StoreLang);
      } else if (this.d_selectedProjectType === 'wanalyzer_create_query') {
        route_path = ClsRoute.f_getRoutePath('user_project_create_data_query', this.StoreLang);
      }
      // console.log('route_path : ', route_path);
      let new_query = {
        'path': route_path,
        'query': {
          'project_id': '',
          'project_type': project_type
        }
      };
      if (ordered_type == 'unordered') {
        this.d_selectedProjectOrderedType = 'unordered';
        if (no_ordered_source == 'dataset') {
          this.d_noOrderedSource = 'dataset';
          let p_id = '';
          try {
            if (this.d_datasetList[this.d_selectedProjectType][this.d_selectedProjectIndex]['data']['0']['37']['val']) {
              p_id = this.d_datasetList[this.d_selectedProjectType][this.d_selectedProjectIndex]['data']['0']['37']['val'];
            }
          } catch(err) {}
          if (p_id) {
            new_query.query.project_id = p_id
          }

          let stats_id = '';
          try {
            if (this.d_datasetList[this.d_selectedProjectType][this.d_selectedProjectIndex]['data']['0']['38']['val']) {
              stats_id = this.d_datasetList[this.d_selectedProjectType][this.d_selectedProjectIndex]['data']['0']['38']['val'];
            }
          } catch(err) {}
          if (stats_id) {
            new_query.query.stats_id = stats_id
          }

          let ml_id = '';
          try {
            if (this.d_datasetList[this.d_selectedProjectType][this.d_selectedProjectIndex]['data']['0']['39']['val']) {
              stats_id = this.d_datasetList[this.d_selectedProjectType][this.d_selectedProjectIndex]['data']['0']['39']['val'];
            }
          } catch(err) {}
          if (ml_id) {
            new_query.query.ml_id = ml_id
          }

        } else {
          this.d_noOrderedSource = '';
          let p_id = '';
          try {
            if (this.d_noNeedOrderProjectList[this.d_selectedProjectType][this.d_selectedProjectIndex]['data']['0']['37']['val']) {
              p_id = this.d_noNeedOrderProjectList[this.d_selectedProjectType][this.d_selectedProjectIndex]['data']['0']['37']['val'];
            }
          } catch(err) {}
          if (p_id) {
            new_query.query.project_id = p_id
          }

          let stats_id = '';
          try {
            if (this.d_noNeedOrderProjectList[this.d_selectedProjectType][this.d_selectedProjectIndex]['data']['0']['38']['val']) {
              stats_id = this.d_noNeedOrderProjectList[this.d_selectedProjectType][this.d_selectedProjectIndex]['data']['0']['38']['val'];
            }
          } catch(err) {}
          if (stats_id) {
            new_query.query.stats_id = stats_id
          }

          let ml_id = '';
          try {
            if (this.d_noNeedOrderProjectList[this.d_selectedProjectType][this.d_selectedProjectIndex]['data']['0']['39']['val']) {
              stats_id = this.d_noNeedOrderProjectList[this.d_selectedProjectType][this.d_selectedProjectIndex]['data']['0']['39']['val'];
            }
          } catch(err) {}
          if (ml_id) {
            new_query.query.ml_id = ml_id
          }

        }
      } else {
        this.d_selectedProjectOrderedType = 'ordered';
        this.d_noOrderedSource = '';
        if (this.d_projectList[this.d_selectedProjectType][this.d_selectedProjectIndex].wanalyzer_project_id) {
          new_query.query.project_id = this.d_projectList[this.d_selectedProjectType][this.d_selectedProjectIndex].wanalyzer_project_id
        }
        if (this.d_projectList[this.d_selectedProjectType][this.d_selectedProjectIndex].wanalyzer_stats_id) {
          new_query.query.stats_id = this.d_projectList[this.d_selectedProjectType][this.d_selectedProjectIndex].wanalyzer_stats_id;
        }
        if (this.d_projectList[this.d_selectedProjectType][this.d_selectedProjectIndex].wanalyzer_machine_learning_id) {
          new_query.query.ml_id = this.d_projectList[this.d_selectedProjectType][this.d_selectedProjectIndex].wanalyzer_machine_learning_id;
        }
      }

      this.$router.push(new_query);
    },
    f_dateFormat: function (date, date_type='year-month-day') {
      if (date) {
        if (date_type === 'year-month-day') {
          if (this.StoreLang === 'tr') {
            let x = moment(date, "YYYY-MM-DD hh:mm:ss").format("DD/MM/YYYY");
            return x;
          } else {
            let x = moment(date, "YYYY-MM-DD hh:mm:ss").format("YYYY/MM/DD");
            return x;
          }
        } else if (date_type === 'year-month-day hh:mm') {
          let x = moment(date, "YYYY-MM-DD hh:mm:ss").format("DD/MM/YYYY HH:MM");
          return x;
        }
      } else {
        return "";
      }
    },
    f_supportModal: function () {
      if (this.d_user) {
        this.d_supportData.show = true;
        this.d_supportData.edit_eligible = true;
        this.d_supportData.operation_name = '';
        this.d_supportData.operation_note = '';
      } else {
        this.$router.push({ path: '/login', query: {} });
      }
    },
    f_getScopes: function () {
      this.d_scopeList = [];
      for (let project of this.d_projectList['wanalyzer_create_query']) {
        if (project['wanalyzer_project_scope']){
          if (this.d_scopeList.indexOf(project['wanalyzer_project_scope']) === -1) {
            this.d_scopeList.push(project['wanalyzer_project_scope'])
          }
        }
      }
    }
  },
  watch: {
    'StoreLang': function () {
      this.d_keyIndex ++;
    }
  }
};

</script>
<style type="text/css">

.normal-mode {}

.full-screen-mode {
  overflow-y: auto;
  overflow-x: hidden;
  background-color: white;
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /*background-color: rgba(0, 0, 0, .5);*/
  /*display: table;*/
/*  -webkit-transition: opacity .3s ease;
  transition: opacity .3s ease;
*/
}


.wai-topbar {
  align-items: center;
  padding: 3px 5px;
  margin: 0 0 14px 0;
  border-radius: 18px;
  background: linear-gradient(135deg, #ffffff 0%, #f5f8fc 100%);
  border: 1px solid #dbe5ef;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

.wai-topbar-fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 68px;
  z-index: 1001;
  margin: 0;
  border-radius: 0;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid #cbd5e1;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.14);
}

.wai-project-dropdown,
.wai-new-project-dropdown {
  width: 100%;
}

.wai-project-dropdown >>> .btn,
.wai-new-project-dropdown >>> .btn {
  width: 100%;
  padding: 0;
  border: none;
  background: transparent;
  box-shadow: none;
}

.wai-project-selector {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 48px;
  padding: 8px 12px;
  border-radius: 16px;
  background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 55%, #0284c7 100%);
  color: white;
  box-shadow: 0 8px 20px rgba(37, 99, 235, 0.22);
}

.wai-project-icon {
  width: 36px;
  height: 36px;
  min-width: 36px;
  border-radius: 12px;
  background: rgba(255,255,255,0.16);
  display: flex;
  align-items: center;
  justify-content: center;
}

.wai-project-text {
  flex: 1;
  min-width: 0;
  text-align: left;
}

.wai-project-label {
  font-size: 14px;
  font-weight: 800;
  line-height: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wai-project-date {
  margin-top: 2px;
  font-size: 11px;
  opacity: 0.82;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wai-project-caret {
  opacity: 0.85;
}

.wai-dropdown-panel {
  width: 620px;
  max-width: 90vw;
  padding: 12px;
  border-radius: 18px;
  background: #ffffff;
  border: 1px solid #dbe5ef;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.18);
}

.wai-auth-panel {
  width: 540px;
}

.wai-dropdown-search {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  margin-bottom: 10px;
  border-radius: 14px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.wai-search-icon {
  width: 30px;
  height: 30px;
  min-width: 30px;
  border-radius: 10px;
  background: #e0f2fe;
  color: #0369a1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wai-search-input {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
  font-size: 13px;
}

.wai-clear-button {
  border: none;
  background: #fee2e2;
  color: #b91c1c;
  border-radius: 10px;
  width: 34px;
  height: 34px;
  cursor: pointer;
}

.wai-project-list {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 520px;
  padding-right: 4px;
}

.wai-project-list::-webkit-scrollbar {
  width: 8px;
}

.wai-project-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 999px;
}

.wai-dropdown-group {
  min-width: 500px;
}

.wai-group-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  margin: 6px 0;
  border-radius: 12px;
  background: linear-gradient(90deg, #eef6ff, #f8fafc);
  color: #0f172a;
  font-weight: 800;
}

.wai-scope-row {
  margin: 4px 0;
  padding: 8px 4px;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid #eef2f7;
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;
  color: #334155;
}

.wai-scope-row:hover {
  background: #e0f2fe;
  color: #075985;
}

.wai-project-item,
.wai-project-item-selected {
  border-radius: 12px;
  margin: 3px 0;
}

.wai-project-item-inner {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 8px 10px;
  border-radius: 12px;
  color: #334155;
  transition: all 0.18s ease;
}

.wai-project-item-inner:hover {
  background: #eff6ff;
  color: #1d4ed8;
  transform: translateX(3px);
}

.wai-project-item-selected .wai-project-item-inner {
  background: linear-gradient(135deg, #dbeafe, #eff6ff);
  color: #1e3a8a;
  font-weight: 800;
  border-left: 4px solid #2563eb;
}

.wai-public-title {
  margin: 12px 0 8px 0;
  padding: 8px 12px;
  border-radius: 12px;
  background: linear-gradient(90deg, #ecfdf5, #f8fafc);
  color: #166534;
  display: flex;
  align-items: center;
  gap: 8px;
}

.wai-loading-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  color: #0369a1;
  font-weight: 700;
}

.wai-topbar-action,
.wai-topbar-fullscreen-action {
  display: flex;
  align-items: center;
  justify-content: center;
}

.wai-new-project-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  min-height: 46px;
  padding: 8px 12px;
  border-radius: 16px;
  background: linear-gradient(135deg, #ecfdf5, #dcfce7);
  color: #166534;
  border: 1px solid #bbf7d0;
  font-weight: 800;
}

.wai-new-project-button:hover {
  background: linear-gradient(135deg, #dcfce7, #bbf7d0);
}

.wai-auth-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 12px;
}

.wai-credit-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 9px;
  border-radius: 999px;
  background: #e0f2fe;
  color: #075985;
  font-weight: 800;
  font-size: 12px;
}

.wai-fullscreen-button {
  width: 46px;
  height: 46px;
  border-radius: 16px !important;
  background: #f8fafc !important;
  color: #0f172a !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
}

.wai-fullscreen-button:hover {
  background: #e0f2fe !important;
  color: #0369a1 !important;
}

.wai-loading-mini {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
